import React from 'react';
import PropTypes from 'prop-types';
import {RenderHTML} from '@learningblocks/storybook-components';
import {TestTubeDropdown} from './TestTubeDropdown';
import {TestTube} from './TestTube';
import {TestTubeLabel} from './TestTubeLabel';
import {TestTubeImage} from './TestTubeImage';
import {TestTubeFeedback} from './TestTubeFeedback';
import './style.scss';

export const MainContent = ({question, samples, onDropdownChange}) => {
  const setSampleCorrect = (sample) =>
    sample.currentValue === sample.actualValue;

  const renderSampleOption = (option) => {
    const isCorrect = setSampleCorrect(option);
    return (
      <TestTube key={option.id}>
        <TestTubeLabel label={option.label} />
        <TestTubeImage label={option.label}>
          <TestTubeDropdown
            id={option.id}
            options={option.options}
            onChange={onDropdownChange}
            showFeedback={option.showFeedback}
            currentValue={option.currentValue}
            isCorrect={isCorrect}
          />
          <TestTubeFeedback
            isCorrect={isCorrect}
            showFeedback={option.showFeedback}
          />
        </TestTubeImage>
      </TestTube>
    );
  };

  const renderTestTubeDropdown = () => samples.map(renderSampleOption);

  return (
    <div className='labelTestTube_content'>
      <div className='labelTestTube_content__question'>
        <RenderHTML content={question} />
      </div>
      <div className='labelTestTube_content__options'>
        {renderTestTubeDropdown()}
      </div>
    </div>
  );
};

MainContent.propTypes = {
  /**
   * String representing question of the card
   */
  question: PropTypes.string.isRequired,
  /**
   * List of samples
   */
  samples: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * Funciton to invoke when an option is selected
   */
  onDropdownChange: PropTypes.func.isRequired,
};
